import { Vector2 } from "peet-math";
import { SimpleAnim } from "./simple-anim-control";
const panim = require('peter-anim-js');

export // Used to show a specific place to the user. "Here are your seats" "Here is the scene" "Here's your friend's seat'
class PlaceIndicationAnim extends SimpleAnim {
  public cssDummy: any;
  public style: any;
  public visible: boolean;
  public shown: boolean;
  public radius: number;
  public maxBGAlpha: number;
  public maxBorderAlpha: number;
  public bgAlpha: number;
  public borderAlpha: number;
  public position: Vector2;
  public anim: any;
  public angle1: number;
  public angle2: number;

  constructor(containerTag: JQuery<HTMLElement>) {
    super(containerTag);
    this.startAt = this.startAt.bind(this);
    this._renderCanvas = this._renderCanvas.bind(this);
    this.containerTag = containerTag;
    super(arguments[0], "placeIndicatorAnim");
  }

  startAt(posOnPlan, renderCb, after) {
    this.position = posOnPlan;
    this.visible = true;
    
    const animEase = panim.getScaledEaseFunct(0, 1, panim.easeLinear);
    return this.anim = new panim.Anim(1000, (t, delta) => {
      const te = animEase(t);

      // p1 act from 0% to 50%
      let tp1 = te * 2;
      if (tp1 > 1) { tp1 = 1; } // Clip
      this.angle1 = -tp1 * Math.PI * 2;

      // p2 act from 40% to 100%
      let tp2 = (te - 0.6) * (1 / (1 - 0.6));
      if (tp2 < 0) { tp2 = 0; } // Clip
      this.angle2 = -tp2 * Math.PI * 2;

      return renderCb();
    }).then(() => {
      this.stop(renderCb);
      if (after != null) {
        return after();
      }
    });
  }
  
  _renderCanvas(viewport, c) {
    const posOnView = viewport.pointPToV(this.position);
    c.beginPath();
    c.arc(posOnView.x, posOnView.y, 60, this.angle2, this.angle1, true);

    //const borderColor = this.style.borderColorObj;
    c.lineWidth = 5;
    c.strokeStyle = this.style.borderColor;  //"rgba(#{borderColor.rgba[0]}, #{borderColor.rgba[1]}, #{borderColor.rgba[2]}, #{@borderAlpha})"
    return c.stroke();
  }
}